import { Component } from "@angular/core";
import { AProgessBarWizardComponent } from "../../components/common/progressbarwizard/iprogressbar.wizard.component";
import { DataSourcePreviewPanel } from '../../workflow/modules/dataoperations/datasource/datasource.settings';

@Component({
    selector: 'iw-summary-page',
    templateUrl: './iw.summary.page.html',
    styleUrls: ['./iw.summary.page.css']
})
export class IntegrationWizardSummaryPage extends AProgessBarWizardComponent {
    ColumnsExpanded = false;
    SelectedColumns = [];

    constructor() {
        super();
        this.CanStepForwardValue = true;
    }

    OnWizardStateSet(): void {
        if (this.WizardState) {
            if (this.WizardState.structure && this.WizardState.structure.Columns) {
                this.SelectedColumns = this.WizardState.structure.Columns.filter((x: any) => x.Selected);
            }
            if (typeof this.WizardState.UseBulk != "boolean") {
                this.WizardState.UseBulk = true;
            }
        }
    }

    showMappedCols() {
        this.ColumnsExpanded != this.ColumnsExpanded;
    }

    showPreview() {
        const rows = [];
        const columns = [];
        if (this.WizardState && this.WizardState.structure && this.WizardState.structure.ColumnPreview) {
            this.SelectedColumns.forEach(col => {
                if (col.MappedColumn) {
                    const colData = this.WizardState.structure.ColumnPreview[col.Name];
                    if (colData) {
                        const colName = this.WizardState.NewTable ? col.MappedColumn.Name : col.MappedColumn.TranslatedCaption;
                        columns.push({
                            Name: colName,
                            Caption: colName,
                            CalculatedWidth: '160px'
                        });
                        for (let i = rows.length; i < colData.length; i++) {
                            rows.push({});
                        };
                        colData.forEach((data: any, i: number) => {
                            rows[i][colName] = data;
                        });
                    }
                }
            });
        }
        DataSourcePreviewPanel.ShowData(rows, columns, '@@IC-Summary-Preview');
    }
}